// import {MdDashboard} from 'react-icons/md';
export const sidebarData = [
  {
    title: "Home",
    path: "/user/home",
    icon: "🏠",
    cName: "nav-text",
  },
  {
    title: "Dashboard",
    path: "/user/dashboard",
    // icon: ()=>{
    //   return <MdDashboard />
    // },
    icon: "📝",
    cName: "nav-text",
  },
  {
    title:"Faq",
    path:"/user/faq",
    icon:"💬",
    cName: "nav-text",
  },
  {
    title:"How it work",
    path:"/user/how-it-works",
    icon:"❔",
    cName: "nav-text",
  },
  {
    title: "Your Profile",
    path: "/user/profile",
    icon: "🧔🏻",
    cName: "nav-text",
  },
  {
    title: "Analytics",
    path: "/user/analytics",
    icon: "📈",
    cName: "nav-text",
  },

];
